import { createSlice } from '@reduxjs/toolkit';
import { getAllActiveLotteries } from './lotteryServices';

const initialState = {
    allActiveLotteries: {
        isLotteriesLoading: null,
        isLotteriesSuccess: null,
        bannerMessage: null,
        lotteries: []
    }
}

const lotterySlice = createSlice({
    name: 'lottery',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getAllActiveLotteries.pending, (state) => {
            state.allActiveLotteries = {
                ...initialState.allActiveLotteries,
                isLotteriesLoading: true,
                bannerMessage: 'Loading lotteries...'
            };
        })
        .addCase(getAllActiveLotteries.rejected, (state, action) => {
            state.allActiveLotteries = {
                ...initialState.allActiveLotteries,
                isLotteriesLoading: false,
                isLotteriesSuccess: false,
                bannerMessage: action.payload
            };
        })
        .addCase(getAllActiveLotteries.fulfilled, (state, action) => {
            state.allActiveLotteries = {
                ...initialState.allActiveLotteries,
                isLotteriesLoading: false,
                isLotteriesSuccess: true,
                bannerMessage: action.payload.message,
                lotteries: action.payload
            };
        })
    }
});

export default lotterySlice.reducer;